import { MenuType } from '@/_models/Menu';

export const createMenuItem = (data) => {
  return {
    id: data.id,
    url: data.itemId, // temporary
    mobileUrl: null,
    title: data.name,
    type: MenuType.BIMItem,
    icon: null,
    order: 0,
    panoramaId: null,
    tag: null,
    changeMinimap: true,
    changePanorama: false,
    labelId: null,
    floorId: null,
    itemId: data.itemId,
    iframeSettings: {
      desktop: {
        sizeType: '',
        width: '',
        height: '',
      },
      mobile: {
        sizeType: '',
        width: '',
        height: '',
      },
    },
    shouldHighlight: false,
    changeReel: false,
    createdAt: '2024-06-10T07:34:23.754Z',
    updatedAt: '2024-06-10T07:34:23.754Z',
    tourId: 5872,
    subMenus: [],
  };
};
